'use client';

import { Chip } from '@coolblue-development/freddy';
import { Clock } from '@coolblue-development/icons';
import { useTranslation } from '@i18n/useTranslation';

type Props = {
  min?: number;
  max?: number;
};

export const HoursChip = ({ min, max }: Props) => {
  const { t } = useTranslation('vacancyDetail.header');

  return (
    <Chip startIcon={<Clock />}>
      {t('hours', {
        min: min,
        max: max
      })}
    </Chip>
  );
};
